import { Action } from 'redux';

export enum ThunkTypes {
    Success = '@@Thunk/SUCCESS',
    Error = '@@Thunk/ERROR',
}

export interface ThunkAction {
    meta:
        | Record<string, unknown>
        | {
              thunk: boolean;
          };
}

export type ThunkPayload<T> = {
    payload?: T;
    meta: Record<string, unknown>;
};

export interface ThunkSuccessAction<T = any> extends Action {
    type: ThunkTypes.Success;
    meta: Record<string, unknown>;
    payload?: T;
}

export interface ThunkErrorAction<T = any> extends Action {
    type: ThunkTypes.Error;
    error: boolean;
    meta: Record<string, unknown>;
    payload?: T;
}
